import { isNilOrEmptyString } from '@tunein/web-utils';
import { mapKeys, mapValues, omitBy } from 'es-toolkit';
import { isEmpty } from 'es-toolkit/compat';
import { v4 as uuidv4 } from 'uuid';
import { defaultTargetingParams } from '../AdPlayer';
const GAM_ADS_URL = 'https://pubads.g.doubleclick.net/gampad/ads';
export function buildGoogleIMAAdTagUrl({ baseParams, isVideoAd, videoApsBids, }) {
    const url = new URL(GAM_ADS_URL);
    const baseAdTagParams = {
        ...defaultTargetingParams,
        ...omitBy(baseParams, isNilOrEmptyString), // filtering early to avoid overriding defaults with empty values
        sid: uuidv4(),
        correlator: Date.now().toString(),
        sz: isVideoAd ? '1x1|400x300|640x360|640x480' : '1x1',
        ad_type: isVideoAd ? 'video' : 'audio',
        cust_params: {
            ...omitBy(baseParams.cust_params || {}, isNilOrEmptyString),
            videoEnabled: isVideoAd ? 'true' : 'false',
            audioEnabled: isVideoAd ? 'false' : 'true',
        },
    };
    const customParamsFiltered = omitBy(baseAdTagParams.cust_params || {}, isNilOrEmptyString);
    const customParamsTransformed = mapValues(customParamsFiltered, String);
    const baseParamsFiltered = omitBy(baseAdTagParams, isNilOrEmptyString);
    const baseParamsTransformed = mapValues(baseParamsFiltered, String);
    if (!isEmpty(customParamsTransformed)) {
        baseParamsTransformed.cust_params = new URLSearchParams(customParamsTransformed)
            .toString()
            .concat(videoApsBids || '');
    }
    else {
        delete baseParamsTransformed.cust_params;
    }
    if (baseParamsTransformed) {
        url.search = new URLSearchParams(baseParamsTransformed).toString();
    }
    return url.toString();
}
const ADSWIZZ_REQUEST_URL = 'https://tunein.deliveryengine.adswizz.com/vast/4.0/request/alias/VAST_Preroll';
export function buildAdsWizzAdTagUrl({ baseParams, customParams, companionSizes, }) {
    const adswizzUrl = new URL(ADSWIZZ_REQUEST_URL);
    const baseAdTagParams = {
        ...baseParams,
        ...(companionSizes && {
            'aw_0_1st.companionAds': 'true',
            companion_zone_alias: companionSizes,
        }),
        'aw_0_1st.skey': '2112133398',
        idtype: 'adid',
        rdid: window.com_adswizz_synchro_getListenerId?.(),
    };
    if (customParams.lotamesegments) {
        customParams.lotamesegments = `;${customParams.lotamesegments.split(',').join(';')};`;
    }
    const adsWizzParameters = {
        ...baseAdTagParams,
        ...mapKeys(customParams, (_, key) => `aw_0_1st.${key}`),
    };
    if (adsWizzParameters) {
        const filteredParams = omitBy(adsWizzParameters, isNilOrEmptyString);
        const transformedParams = mapValues(filteredParams, String);
        adswizzUrl.search = new URLSearchParams(transformedParams).toString();
    }
    return adswizzUrl.toString();
}
